import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import PasswordInput from "@/components/PasswordInput";
import { api } from "@/lib/api";
import { apiError } from "@/lib/format";

export const ChangePasswordDialog = ({ trigger }) => {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 6) return toast.error("A nova senha deve ter pelo menos 6 caracteres");
    if (pwd !== pwd2) return toast.error("As senhas não coincidem");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pwd });
      toast.success("Senha alterada com sucesso!");
      setOpen(false); setCur(""); setPwd(""); setPwd2("");
    } catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <>
      <span onClick={() => setOpen(true)}>{trigger}</span>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-surface border-white/10 text-white max-w-sm" data-testid="change-password-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl uppercase flex items-center gap-2"><KeyRound className="w-6 h-6 text-brand" /> Alterar senha</DialogTitle></DialogHeader>
          <form onSubmit={submit} className="space-y-3">
            <div><Label className="text-slate-300">Senha atual</Label><PasswordInput testId="cp-current" required value={cur} onChange={(e) => setCur(e.target.value)} className="bg-ink border-white/10 mt-1" /></div>
            <div><Label className="text-slate-300">Nova senha</Label><PasswordInput testId="cp-new" required minLength={6} value={pwd} onChange={(e) => setPwd(e.target.value)} className="bg-ink border-white/10 mt-1" /></div>
            <div><Label className="text-slate-300">Confirmar nova senha</Label><PasswordInput testId="cp-confirm" required minLength={6} value={pwd2} onChange={(e) => setPwd2(e.target.value)} className="bg-ink border-white/10 mt-1" /></div>
            <Button data-testid="cp-submit" type="submit" disabled={busy} className="w-full bg-brand hover:bg-brand-hover font-bold uppercase h-11">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Salvar nova senha"}
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ChangePasswordDialog;
